module.exports = __webpack_public_path__ + "media/images/gift_plan/gift-pop-out-16fff8db233b5736fedf3487777f7bf2.png";